var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoCity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "27px",
    viewBox: "0 0 29 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1931D1B6-E267-4DED-A806-58130F3E2257") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-130.000000, -739.000000)",
    fillRule: "nonzero",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "cityy",
    transform: "translate(130.000000, 739.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tpye",
    transform: "translate(8.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1,1.66473545 L1,26 L13,26 L13,8.04897191 L1,1.66473545 Z",
    id: "Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.0178223,20.5 L18.0140381,20.5",
    id: "Path-38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.01782227,20.5 L6,20.5",
    id: "Path-38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.01782227,16.5 L6,16.5",
    id: "Path-38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.01782227,12.5 L6,12.5",
    id: "Path-38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0178223,16.5 L18.0140381,16.5",
    id: "Path-38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0178223,12.5 L18.0140381,12.5",
    id: "Path-38"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 21,
    y: 12,
    width: 7,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 1,
    y: 8,
    width: 8,
    height: 18
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCity);
export default __webpack_public_path__ + "static/media/ico_city.097a7118e8693c71028f3b19a9cdb4c9.svg";
export { ForwardRef as ReactComponent };